import { inject, Injectable } from '@angular/core';
import { ApiConfig, ApiHttpService } from '@capturum/api';
import { FormulaCatalog, LspCatalogs } from '@shared/interfaces/lsp.interface';
import { map, Observable, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LspCatalogService {
  readonly #http = inject(ApiHttpService);
  readonly #apiConfig = inject(ApiConfig);

  #catalogs$?: Observable<LspCatalogs>;

  /** All registered module catalogs, fetched once and cached for the session. */
  public getCatalogs(): Observable<LspCatalogs> {
    if (!this.#catalogs$) {
      this.#catalogs$ = this.#http.get<{ data: LspCatalogs }>('/lsp').pipe(
        map((response) => response.data ?? {}),
        shareReplay(1),
      );
    }

    return this.#catalogs$;
  }

  /** The formula catalog, or an empty catalog when the namespace is absent. */
  public getFormulas(): Observable<FormulaCatalog> {
    return this.getCatalogs().pipe(map((catalogs) => catalogs.formula ?? {}));
  }
}
